import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { useTranslation } from '@refinedev/core';
import { t } from 'i18next';

interface AddUserModalProps {
  open: boolean;
  onClose: () => void;
}

export const AddUserModal: React.FC<AddUserModalProps> = ({
  onClose,
  open,
}) => {
  const { translate } = useTranslation();
  const [form] = Form.useForm();

  const handleSubmit = () => {
    onSubmit();
    form.resetFields();
  };
  const onSubmit = (/*values: {
    firstName: string;
    lastName: string;
    email: string;
  }*/) => {
    onClose();
  };
  return (
    <Modal
      open={open}
      title={t('users.addUser')}
      onCancel={onClose}
      onOk={handleSubmit}
      footer={[
        <Button key="back" onClick={onClose}>
          {translate('buttons.cancel')}
        </Button>,
        <Button key="submit" type="primary">
          {translate('buttons.create')}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="firstName"
          label={t('users.firstName')}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="lastName"
          label={t('users.lastName')}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label={t('users.email')}
          rules={[{ required: true, type: 'email' }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
